import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";

const AdminProjects = () => {
  const [layouts, setLayouts] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [bookedInput, setBookedInput] = useState("");
  const [onHoldInput, setOnHoldInput] = useState("");
  const [newLayoutName, setNewLayoutName] = useState("");
  const [layoutImage, setLayoutImage] = useState(null);
  const [mode, setMode] = useState("existing"); // "new" or "existing"

  // Fetch layouts on mount
  useEffect(() => {
    axios.get("http://localhost:5000/layouts").then((res) => {
      setLayouts(res.data);
      if (res.data.length > 0) setSelectedLayout(res.data[0]);
    });
  }, []);

  // When layout changes, fill booked & onHold inputs
  useEffect(() => {
  if (selectedLayout) {
    setBookedInput(Array.isArray(selectedLayout.booked) ? selectedLayout.booked.join(", ") : "");
    setOnHoldInput(Array.isArray(selectedLayout.onHold) ? selectedLayout.onHold.join(", ") : "");
  }
}, [selectedLayout]);


  // Save updates for existing layout
  const handleSaveExisting = async () => {
    if (!selectedLayout) return;

    const updated = {
      ...selectedLayout,
      booked: bookedInput
        .split(",")
        .map((n) => parseInt(n.trim()))
        .filter((n) => !isNaN(n)),
      onHold: onHoldInput
        .split(",")
        .map((n) => parseInt(n.trim()))
        .filter((n) => !isNaN(n)),
    };

    // If a new image is uploaded, include it
    if (layoutImage) {
      const formData = new FormData();
      formData.append("image", layoutImage);
      Object.keys(updated).forEach((key) => formData.append(key, updated[key]));
      const res = await axios.put(
        `http://localhost:5000/layouts/${selectedLayout._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setLayouts(layouts.map((l) => (l._id === res.data._id ? res.data : l)));
      setSelectedLayout(res.data);
    } else {
      const res = await axios.put(
        `http://localhost:5000/layouts/${selectedLayout._id}`,
        updated
      );
      setLayouts(layouts.map((l) => (l._id === res.data._id ? res.data : l)));
      setSelectedLayout(res.data);
    }

    setLayoutImage(null);
    alert("✅ Layout updated!");
  };

  // Add a new layout
  const handleAddLayout = async () => {
    if (!newLayoutName || !layoutImage) {
      alert("Please provide layout name and image!");
      return;
    }

    const formData = new FormData();
    formData.append("name", newLayoutName);
    formData.append("image", layoutImage);

    const res = await axios.post("http://localhost:5000/layouts/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    setLayouts([...layouts, res.data]);
    setNewLayoutName("");
    setLayoutImage(null);
    alert("✅ New layout added!");
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "20px" }}>
        <h2>⚙️ Admin Panel</h2>

        {/* Mode Selection */}
        <div style={{ marginBottom: "20px" }}>
          <label>
            <input
              type="radio"
              value="new"
              checked={mode === "new"}
              onChange={() => setMode("new")}
            />{" "}
            Add New Layout
          </label>
          <label style={{ marginLeft: "20px" }}>
            <input
              type="radio"
              value="existing"
              checked={mode === "existing"}
              onChange={() => setMode("existing")}
            />{" "}
            Edit Existing Layout
          </label>
        </div>

        {mode === "new" && (
          <div style={{ marginBottom: "30px", border: "1px solid #ccc", padding: "15px" }}>
            <h3>Add New Layout</h3>
            <input
              type="text"
              placeholder="Layout Name"
              value={newLayoutName}
              onChange={(e) => setNewLayoutName(e.target.value)}
            />
            <input type="file" onChange={(e) => setLayoutImage(e.target.files[0])} />
            <button onClick={handleAddLayout}>Add Layout</button>
          </div>
        )}

        {mode === "existing" && layouts.length > 0 && (
          <div style={{ border: "1px solid #ccc", padding: "15px" }}>
            <h3>Edit Existing Layout</h3>

            <div style={{ marginBottom: "20px" }}>
              <label>Select Layout: </label>
              <select
                value={selectedLayout?._id}
                onChange={(e) => {
                  const layout = layouts.find((l) => l._id === e.target.value);
                  setSelectedLayout(layout);
                }}
              >
                {layouts.map((layout) => (
                  <option key={layout._id} value={layout._id}>
                    {layout.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Layout preview */}
            {selectedLayout?.image && (
              <div style={{ marginBottom: "20px" }}>
                <h4>Layout Preview:</h4>
                <img
                  src={`http://localhost:5000${selectedLayout.image}`}
                  alt={selectedLayout.name}
                  style={{ width: "400px", border: "1px solid #ccc" }}
                />
              </div>
            )}

            <div>
              <label>Booked Plots: </label>
              <input
                type="text"
                value={bookedInput}
                onChange={(e) => setBookedInput(e.target.value)}
              />
            </div>

            <div>
              <label>On Hold Plots: </label>
              <input
                type="text"
                value={onHoldInput}
                onChange={(e) => setOnHoldInput(e.target.value)}
              />
            </div>

            <button onClick={handleSaveExisting}>Save Changes</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminProjects;
